import { AfterViewInit, ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';

import { each, map } from 'lodash-es';

import { AddressEnum } from '../../../../../../enums/address';
import { ProfileSearchEnum } from '../../../../../../enums/profile-search';
import * as fromMonetizationActions from '../../../../../../store/actions/monetization.actions';
import * as fromWalkingFarmActions from '../../../../../../store/actions/walking-farm.actions';
import { PhoneAndEmailPurchaseWalkingFarmProperty } from '../../../../../../typings/walking-farm';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-phone-and-email-purchase-modal',
  standalone: false,
  templateUrl: './phone-and-email-purchase-modal.component.html'
})
export class PhoneAndEmailPurchaseModalComponent implements AfterViewInit {
  private modalController = inject(ModalController);
  private store = inject(Store);

  farmId = '';

  properties: PhoneAndEmailPurchaseWalkingFarmProperty[] = [];

  filterText = '';

  isEntireFarmSelected = true;

  selectedProperties: string[] = [];

  searchType!: ProfileSearchEnum;

  close() {
    return this.modalController.dismiss(null, 'cancel');
  }

  confirm() {
    if (this.selectedProperties.length) {
      this.store.dispatch(
        fromMonetizationActions.purchasePhoneAndEmailPreview({
          payload: {
            farmId: this.farmId,
            propertyIds: this.selectedProperties,
            searchType: this.searchType
          }
        })
      );
    }
  }

  filterProperties(event: CustomEvent) {
    this.filterText = event.detail.value;
  }

  clearFilterProperties() {
    this.filterText = '';
  }

  ngAfterViewInit() {
    this.updateEntireFarmSelection();
  }

  propertiesListTrackBy(_index: number, property: PhoneAndEmailPurchaseWalkingFarmProperty) {
    return property.A000_PropertyNumber;
  }

  toggleEntireFarm() {
    this.isEntireFarmSelected = !this.isEntireFarmSelected;
    this.updateEntireFarmSelection(this.isEntireFarmSelected);
  }

  toggleProperty(propertyId: string | number) {
    this.properties = map(this.properties, (property) => ({
      ...property,
      phoneAndEmailIsSelected:
        property.A000_PropertyNumber === propertyId
          ? !property.phoneAndEmailIsSelected
          : property.phoneAndEmailIsSelected
    }));
    this.updateSelectedPropertiesList();
  }

  updateEntireFarmSelection(isEntireFarmSelected?: boolean) {
    this.properties = map(this.properties, (property) => ({
      ...property,
      phoneAndEmailIsSelected:
        isEntireFarmSelected === undefined ? property.phoneAndEmailIsSelected : isEntireFarmSelected
    }));

    this.updateSelectedPropertiesList();
  }

  updateSelectedPropertiesList() {
    const selectedProperties: string[] = [];
    each(this.properties, (property) => {
      if (property.phoneAndEmailIsSelected) {
        selectedProperties.push(`${property.A000_PropertyNumber}`);
      }
    });
    if (selectedProperties.length === this.properties.length && !this.isEntireFarmSelected) {
      this.isEntireFarmSelected = true;
    } else if (selectedProperties.length !== this.properties.length && this.isEntireFarmSelected) {
      this.isEntireFarmSelected = false;
    }
    this.store.dispatch(
      fromWalkingFarmActions.updatePhoneAndEmailSelectedPropertyIds({
        payload: {
          farmId: this.farmId,
          phoneAndEmailSelectedPropertyIds: selectedProperties
        }
      })
    );
    this.selectedProperties = selectedProperties;
  }

  protected readonly addressEnum = AddressEnum;
}
